import { ProcessTypeModel } from '@app/models/ProcessTypeModel';
import { ProcessTypeRepository } from '@app/repositories/ProcessTypeRepository';
import { ServiceBase } from '@app/services/ServiceBase';

export class ProcessTypeService extends ServiceBase<ProcessTypeModel, ProcessTypeRepository<ProcessTypeModel>> {
    public constructor() {
        super(new ProcessTypeRepository());
    }
}
